import Block from 'Mixins/Block';

export default Block('component-youtube', {
	fn: {},
	onLoad() {
		const setupOverlays = function () {
			const finishedClass = 'finished-playing';
			console.log(finishedClass);
			var tag = document.createElement('script');
			tag.src = 'https://www.youtube.com/iframe_api';
			var firstScriptTag = document.getElementsByTagName('script')[0];
			firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

			const onYouTubeIframeAPIReady = () => {
				const youtubeFrames = document.querySelectorAll('iframe[src^="https://www.youtube"]');
				youtubeFrames.forEach(youtubeFrame => {
					const youtubeElement = youtubeFrame.parentElement;
					// Check if the src URL contains the '?enablejsapi=1' query parameter
					// Append '?enablejsapi=1' if not already present
					let src = youtubeFrame.src;
					if (!src.includes('?enablejsapi=1') && !src.includes('&enablejsapi=1')) {
						if (src.includes('?')) {
							src += '&enablejsapi=1'; // Add '&enablejsapi=1' if there are other query parameters
						} else {
							src += '?enablejsapi=1'; // Add '?enablejsapi=1' if it's the first query parameter
						}
						youtubeFrame.src = src;
					}
					// eslint-disable-next-line no-undef
					let player = new YT.Player(youtubeFrame, {
						events: {
							'onStateChange': function (event) {
								// eslint-disable-next-line no-undef
								if (event.data === YT.PlayerState.ENDED) {
									youtubeElement.classList.add(finishedClass);
									//Restart video when clicked
									youtubeElement.addEventListener('click', function () {
										player.seekTo(0);
										youtubeElement.classList.remove(finishedClass);
									}, { once: true });
								}
							}
						}
					});
				});
			};
			window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
		};
		const youtubeElements = document.querySelectorAll('iframe[src^="https://www.youtube"]');
		if(youtubeElements.length > 0) {
			setupOverlays();
		}
	},
});
